// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2UKiC","isDesktopOnly":"Button_isDesktopOnly__UIrNo"};